import i18n from '../../../i18n/setupLocalization'
import LocalizationKeys from '../../../i18n/LocalizationKeys'
import { requiredRule, urlRule } from '../../../helpers/rules'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, Row, Space, Typography } from 'antd'

const { Text } = Typography

const ButtonsEditor = () => {
  return (
    <Space direction="vertical" className="w-full">
      <Text>{i18n.t(LocalizationKeys.Misc.Form.Buttons)}</Text>
      <Form.List name="buttons">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row
                key={key}
                style={{ display: 'flex', marginBottom: 8 }}
                gutter={[8, 16]}
              >
                <Col span={8}>
                  <Form.Item
                    {...restField}
                    className="m-0"
                    name={[name, 'title']}
                    rules={[requiredRule()]}
                  >
                    <Input
                      placeholder={i18n.t(LocalizationKeys.Misc.Form.Label)}
                    />
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item
                    {...restField}
                    className="m-0"
                    name={[name, 'url']}
                    rules={[requiredRule(), urlRule()]}
                  >
                    <Input
                      placeholder={i18n.t(LocalizationKeys.Misc.Form.URL)}
                    />
                  </Form.Item>
                </Col>
                <Col span={2}>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => remove(name)}
                  />
                </Col>
              </Row>
            ))}
            <Form.Item>
              {fields.length < 3 && (
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  {i18n.t(LocalizationKeys.Misc.Form.AddButtonInteraction)}
                </Button>
              )}
            </Form.Item>
          </>
        )}
      </Form.List>
    </Space>
  )
}

export default ButtonsEditor
